import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { HomeComponent } from './user/home/home.component';
import { UsermodulesComponent } from './modules/usermodules/usermodules.component';
import { DashboardComponent } from './user/dashboard/dashboard.component';
import { DetailsComponent } from './class/details/details.component';
import { LoginComponent } from './useraccess/login/login.component';
import { UseraccessskinComponent } from './useraccess/useraccessskin/useraccessskin.component';
import { ForgotpasswordComponent } from './useraccess/forgotpassword/forgotpassword.component';
import { RegisterComponent } from './useraccess/register/register.component';
import { ForumComponent } from './class/forum/forum.component';
import { ChangepasswordComponent } from './useraccess/changepassword/changepassword.component';
import { ConfirmemailComponent } from './useraccess/confirmemail/confirmemail.component';
import { CreateschoolComponent } from './schools/createschool/createschool.component';
import { SchoolhomeComponent } from './schools/schoolhome/schoolhome.component';
import { AuthGuardGuard } from './authEngine/auth-guard.guard';
import { ModuleDetailsComponent } from './modules/details/details.component';
import { AllmodulesComponent } from './modules/allmodules/allmodules.component';
import { UserschoolsComponent } from './schools/userschools/userschools.component';

import { NewassessmentComponent } from './assessments/newassessment/newassessment.component';
import { AssessmentconsoleComponent } from './assessments/assessmentconsole/assessmentconsole.component';
import { BufferComponent } from './assessments/buffer/buffer.component';
import { AssessmentdetailsComponent } from './assessments/assessmentdetails/assessmentdetails.component';
import { AddquestionComponent } from './assessments/addquestion/addquestion.component';
import { ModuleeditorComponent } from './modules/moduleeditor/moduleeditor.component';
import { ClassnoteComponent } from './class/classnote/classnote.component';
import { CreateComponent } from './class/create/create.component';
import { ModuleMediaLibraryComponent } from './modules/media-library/media-library.component';
import { ModuleMediaLibraryUploadComponent } from './modules/media-library-upload/media-library-upload.component';
import { ModuleMediaComponent } from './modules/media/media.component';
import { ManageadminusersComponent } from './modules/manageadminusers/manageadminusers.component';
import { AddExternalMediaComponent } from './class/add-external-media/add-external-media.component';
import { IndexComponent } from './index/index.component';
import { LogoutComponent } from './useraccess/logout/logout.component';
import { ExternalauthComponent } from './useraccess/externalauth/externalauth.component';
import { UserprofileComponent } from './user/userprofile/userprofile.component';
import { UserprofileeditorComponent } from './user/userprofileeditor/userprofileeditor.component';
import { StudentassessmentdetailsComponent } from './assessments/studentassessmentdetails/studentassessmentdetails.component';
import { AssessmentSubmissionsComponent } from './assessments/assessment-submissions/assessment-submissions.component';
import { ScoreAssessmentComponent } from './assessments/score-assessment/score-assessment.component';
import { AssessmentMarksheetComponent } from './assessments/assessment-marksheet/assessment-marksheet.component';
import { StudentassessmentlistComponent } from './assessments/studentassessmentlist/studentassessmentlist.component';
import { FaqhomeComponent } from './faq/faqhome/faqhome.component';
import { ResendverificationemailComponent } from './useraccess/resendverificationemail/resendverificationemail.component';
import { SchedulelivelessonComponent } from './class/schedulelivelesson/schedulelivelesson.component';
import { RecordvideoComponent } from './class/recordvideo/recordvideo.component';
import { SchoolaccountdashboardComponent } from './schools/schoolaccountdashboard/schoolaccountdashboard.component';
//import { AccountinformationComponent } from './billing/accountinformation/accountinformation.component';
import { MyaccountbillsComponent } from './billing/myaccountbills/myaccountbills.component';
import { BilldetailsComponent } from './billing/billdetails/billdetails.component';
import { AttendanceComponent } from './class/attendance/attendance.component';
import { SchoolstudentlistComponent } from './schools/schoolstudentlist/schoolstudentlist.component';
import { ModulestudentlistComponent } from './modules/modulestudentlist/modulestudentlist.component';
import { SchoolplansComponent } from './billing/schoolplans/schoolplans.component';
//import { VcircleplansComponent } from './billing/vcircleplans/vcircleplans.component';
import { AccountdetailsComponent } from './billing/accountdetails/accountdetails.component';
import { ModulePackagesComponent } from './modulepackage/module-packages/module-packages.component';
import { ModulePackageDetailsComponent } from './modulepackage/module-package-details/module-package-details.component';
import { ModulePackageEditorComponent } from './modulepackage/module-package-editor/module-package-editor.component';
import { AccountsettingsComponent } from './billing/accountsettings/accountsettings.component';
import { SchoolNotFoundComponent } from './school-not-found/school-not-found.component';
import { NotFoundComponent } from './schools/not-found/not-found.component';
import { SendMailComponent } from './schools/send-mail/send-mail.component';
import { CollectiondetailsComponent } from './collections/collectiondetails/collectiondetails.component';
import { ViewCourseAssessmentsComponent } from './assessments/view-course-assessments/view-course-assessments.component';
import { AddEventComponent } from './event/add-event/add-event.component';
import { ViewEventsComponent } from './event/view-events/view-events.component';
import { ViewCustomCssComponent } from './customisation/custom-css/custom-css.component';
import { ModuleBatchesComponent } from './modules/module-batches/module-batches.component';
import { ViewModuleBatchComponent } from './modules/view-module-batch/view-module-batch.component';
import { CustomCertificateComponent } from './customisation/custom-certificate/custom-certificate.component';
import { CustomIndexComponent } from './customisation/custom-index/custom-index.component';
//import { SampleVcircleIframeComponent } from './sample-vcircle-iframe/sample-vcircle-iframe.component';
import { MeetingPageComponent } from './meeting/meeting-page/meeting-page.component';

const routes: Routes = [
  //{ path: 'sample-vcircle-iframe', component: SampleVcircleIframeComponent, pathMatch: 'full' },
  // { path : "" , redirectTo : "user/dashboard", pathMatch : "full"},
  { path: '', component: IndexComponent },
  { path: 'user', redirectTo: '/user/dashboard', pathMatch: 'full' },
  { path: 'module', redirectTo: 'user/moduledetails', pathMatch: 'full' },
  { path: 'assessments', redirectTo: 'assessments/console', pathMatch: 'full' },
  { path: 'schoolnotfound', component: SchoolNotFoundComponent, pathMatch: 'full' },
  {
    path: 'user',
    canActivateChild: [AuthGuardGuard],
    component: HomeComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'usermodules', component: UsermodulesComponent },
      { path: 'userschools', component: UserschoolsComponent },
      { path: 'lesson', component: DetailsComponent },
      { path: 'lessonnote', component: ClassnoteComponent },
      { path: 'schedulelivelesson', component: SchedulelivelessonComponent },
      { path: 'attendance', component: AttendanceComponent },
      { path: 'moduledetails', component: ModuleDetailsComponent },
      { path: 'editmodule', component: ModuleeditorComponent },
      { path: 'uploadmedia', component: ModuleMediaLibraryUploadComponent },
      // {path: "addyoutubemedia", component: ModuleMediaLibraryAddYoutubeComponent},
      { path: 'forum/:id', component: ForumComponent },
      { path: 'forum', component: ForumComponent },
      { path: 'createschool', component: CreateschoolComponent },
      { path: 'schoolhome', component: SchoolhomeComponent },
      { path: 'searchmodules', component: AllmodulesComponent },
      { path: 'editlesson', component: CreateComponent },
      { path: 'modulemedialibrary', component: ModuleMediaLibraryComponent },
      { path: 'manageadminusers', component: ManageadminusersComponent },
      { path: 'userprofile', component: UserprofileComponent },
      { path: 'editprofile', component: UserprofileeditorComponent },
      { path: 'updatepassword', component: ChangepasswordComponent },
      { path: 'schoolstudentlist', component: SchoolstudentlistComponent },

      // -- assessment section
      { path: 'assessmentconsole', component: AssessmentconsoleComponent },
      { path: 'assessmentdetails', component: AssessmentdetailsComponent },
      { path: 'addquestion', component: AddquestionComponent },
      { path: 'newassessment', component: NewassessmentComponent },
      {
        path: 'studentassesment',
        component: StudentassessmentdetailsComponent,
      },
      { path: 'editassessment', component: NewassessmentComponent },
      {
        path: 'assessmentsubmissions',
        component: AssessmentSubmissionsComponent,
      },
      { path: 'allassessments', component: ViewCourseAssessmentsComponent },

      { path: 'scoreassessment', component: ScoreAssessmentComponent },
      { path: 'assessmentmarksheet', component: AssessmentMarksheetComponent },
      { path: 'studentassessments', component: StudentassessmentlistComponent },
      //-- school account dashboard
      {
        path: 'subscriptiondashboard',
        component: SchoolaccountdashboardComponent,
      },
      {
        path: 'modulestudentlist',
        component: ModulestudentlistComponent,
      },
      { path: 'packages', component: ModulePackagesComponent},
      { path: 'packagedetails', component: ModulePackageDetailsComponent },
      { path: 'editpackage', component: ModulePackageEditorComponent },
      { path: 'notfound', component: NotFoundComponent },
      { path: 'sendmail', component: SendMailComponent },
      { path: 'allassessments', component: ViewCourseAssessmentsComponent },
      { path: 'modulebatches', component: ModuleBatchesComponent },
      { path: 'viewmodulebatch', component: ViewModuleBatchComponent }
    ],
  },
  {
    path: 'site',
    component: HomeComponent,
    children: [
      { path: 'schoolhome', component: SchoolhomeComponent },
      { path: 'moduledetails', component: ModuleDetailsComponent },
      { path: 'searchmodules', component: AllmodulesComponent },
      { path: 'packages', component: ModulePackagesComponent },
      { path: 'packagedetails', component: ModulePackageDetailsComponent },
      { path: 'notfound', component: NotFoundComponent }
    ],
  },
  { path: 'recordvideo', component: RecordvideoComponent },

  { path: 'buffer', component: BufferComponent },

  //   { path : "assessments",
  //     component : HomeComponent,
  //     children : [
  //       {path : "console", component: AssessmentconsoleComponent},
  //      // {path :"buffer", component : BufferComponent},
  //       {path :"details", component : AssessmentdetailsComponent},
  //       {path :"addquestion", component : AddquestionComponent},
  //       {path :"new", component : NewassessmentComponent},
  //       {path :"edit", component : NewassessmentComponent}
  //     ]
  // },

  { path: 'login', redirectTo: 'access/login', pathMatch: 'full' },
  { path: 'logout', component: LogoutComponent },
  {
    path: 'forgotpassword',
    redirectTo: 'access/forgotpassword',
    pathMatch: 'full',
  },
  {
    path: 'resetpassword',
    redirectTo: 'access/resetpassword',
    pathMatch: 'full',
  },
  { path: 'register', redirectTo: 'access/register', pathMatch: 'full' },
  { path: 'access', redirectTo: 'access/login', pathMatch: 'full' },
  { path: 'externalauth', component: ExternalauthComponent },
  {
    path: 'access',
    component: UseraccessskinComponent,
    children: [
      { path: 'login', component: LoginComponent },

      { path: 'forgotpassword', component: ForgotpasswordComponent },
      { path: 'register', component: RegisterComponent },
      { path: "resetpassword", component: ChangepasswordComponent },
      { path: 'confirmemail', component: ConfirmemailComponent },
      {
        path: 'resendemailverification',
        component: ResendverificationemailComponent,
      },
    ],
  },
  { path: 'media', component: ModuleMediaComponent },
  {
    path: 'Class/ClassVideo/:classid',
    component: ModuleMediaComponent,
    data: { legacy: true },
  },
  {
    path: 'faq',
    component: HomeComponent,
    children: [{ path: 'home', component: FaqhomeComponent }],
  },
  {
    path: 'account',
    canActivateChild: [AuthGuardGuard],
    component: HomeComponent,
    children: [
      { path: 'accountsettings', component: AccountdetailsComponent },
      { path: 'schoolplan', component: SchoolplansComponent },
      //{ path: 'vcircleplan', component: VcircleplansComponent },
      { path: 'accountdetails', component: AccountsettingsComponent },
  ]
  },
  {
    path: 'billing',
    canActivateChild: [AuthGuardGuard],
    component: HomeComponent,
    children: [
      { path: 'billinginformation', redirectTo: 'bills' },
      { path: 'bills', component: MyaccountbillsComponent },
      { path: 'billdetails', component: BilldetailsComponent },

    ],
  },
  {
    path: 'collection',
    canActivateChild: [AuthGuardGuard],
    component: HomeComponent,
    children: [
      { path: 'collections', component: CollectiondetailsComponent },
    ],
  },
  {
    path: 'events',
    canActivateChild: [AuthGuardGuard],
    component: HomeComponent,
    children: [
      { path: 'add', component: AddEventComponent },
      { path: 'view', component: ViewEventsComponent },
    ],
  },
  {
    path: 'customisation',
    canActivateChild: [AuthGuardGuard],
    component: HomeComponent,
    children: [
      { path: 'css', component: ViewCustomCssComponent },
      { path: 'certificate', component: CustomCertificateComponent },
    ],
  },
  {
    path: 'live',
    canActivate: [AuthGuardGuard],
    component: MeetingPageComponent,
  },
];
const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

